
import FootNav from '../../components/FootNav.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'


export default {
components: {
Panel,
Swiper,
Grid,
GridItem,
FootNav
},
data() {
return {
categoryList:[],
list: [],
swiperList: [],
loadFlag:false,
}
},
created: function () {
document.title='天一互联'
this.$vux.loading.show('加载中');
this.$http.get(this.tianYiWebUrl + '/wechat/news/ajaxGetNewIndex').then(r => {
if (r.data.code === 200) {

let swiperListOrigin = r.data.data.topSwiper;
for (let  x in swiperListOrigin) {
swiperListOrigin[x].img = this.tianYiWebUrl + swiperListOrigin[x].img
swiperListOrigin[x].url= '/news/' + swiperListOrigin[x].id
}


let dataOrigin = r.data.data.list;
for (var x in dataOrigin) {
var dataY = dataOrigin[x].groupList;
let cateId = 0;
for (var y in dataY){
dataY[y].src = this.tianYiWebUrl + dataY[y].src
dataY[y].url= '/news/' + dataY[y].id
cateId = dataY[y].cateId
}
dataOrigin[x].footer = {
title: '查看更多',
url: '/news/cate/' + cateId
}
}

this.categoryList = r.data.data.categoryList
this.swiperList = swiperListOrigin;
this.list = dataOrigin;


this.loadFlag = true;
this.$vux.loading.hide();
} else {
this.$vux.loading.hide();
this.$vux.toast.show({type: 'warn', text: '加载失败'});
}
})
},
methods: {
infiniteHandler($state) {
const url = this.tianYiWebUrl + '/wechat/news/ajaxGetNewIndex';

if (!this.page[this.cateType])
this.page[this.cateType] = 1;

this.$http.get(url, {params: {type: this.cateType, page: this.page[this.cateType]}}).then(res => {
if (res.data.code === 200) {
let vRes = res.data.data;
if (this.list[this.cateType] === undefined) {
this.$set(this.list, [this.cateType], vRes.data);
} else {
this.$set(this.list, [this.cateType], [...this.list[this.cateType], ...vRes.data]);
}

if (vRes.total > (vRes.per_page * vRes.current_page)) {
this.page[this.cateType]++;
$state.loaded()
} else {
$state.complete();
}
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/news/Index.vue